export const MANUFACTURING_SUBLINE_MODAL_EVENT = 'parts:modals:manufacturing-subline';
export const MANUFACTURING_SUBLINE_MODAL_OPEN = `${MANUFACTURING_SUBLINE_MODAL_EVENT}:open`;
export const MANUFACTURING_SUBLINE_MODAL_CLOSE = `${MANUFACTURING_SUBLINE_MODAL_EVENT}:close`;
